import { APP_ROUTES } from '@/routes';
import { createListCollection } from '@chakra-ui/react';
import { polarizedListCollection } from '../configs';
import { useRouter } from 'next/navigation';
import { useListProductFiltersQuery, useListProductsQuery } from './products';
import { WebContractListProductsQueryParams } from '@packages/contracts';

const useSpecialPrice = (productQueryParams: WebContractListProductsQueryParams) => {
	const router = useRouter();
	const handleNavigateToProductDetail = (
		collectionSlug: string,
		productSlug: string,
	) => {
		const url = APP_ROUTES.SHOP.PRODUCT_DETAILS.replace(
			':collectionSlug',
			collectionSlug,
		).replace(':productSlug', productSlug);
		router.push(url);
	};

	const { isLoading, data: productList } = useListProductsQuery(productQueryParams);
	const { data: filters } = useListProductFiltersQuery();

	const frameShapeListCollection = filters
		? createListCollection({
			items: filters.frameShapes.map(frameShape => ({
				value: frameShape,
				label: frameShape,
			})),
		})
		: undefined;

	const frameColorListCollection = filters
		? createListCollection({
			items: filters.frameColors.map(frameShape => ({
				value: frameShape,
				label: frameShape,
			})),
		})
		: undefined;

	const lensColorListCollection = filters
		? createListCollection({
			items: filters.lensColors.map(frameShape => ({
				value: frameShape,
				label: frameShape,
			})),
		})
		: undefined;

	return {
		isLoading,
		filters: filters
			? {
				frameShapeListCollection: frameShapeListCollection!,
				frameColorListCollection: frameColorListCollection!,
				lensColorListCollection:  lensColorListCollection!,
				polarizedListCollection,
			}
			: undefined,
		handleNavigateToProductDetail,
		productList,
	};
};

export default useSpecialPrice;
